import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import SincanIntro from "../components/ServiceRegions/İntros/SincanIntro";
import DynamicImage from "../components/DynamicImage";


const SincanPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      {/* <AboutSection/> */}
      <DynamicImage />
      <SincanIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default SincanPage;
